import React from "react";
import DynamicSelect from "../shared/DynamicSelect";
import { formatValidInput, formatValidSelect, roundToDecimals } from "../../helpers/FormatHelper";
import { useState } from "react";
import NumberInput from "../shared/NumberInput";
import { DeleteTwoTone, RemoveCircleOutline, AddCircleOutlineOutlined, AutorenewRounded, CurrencyExchange, MonetizationOn, MonetizationOnOutlined } from "@material-ui/icons";
import { useEffect } from "react";
import { DenominationTypes } from "../../constants/DenominationTypes";
import OrderInformationDenomination from "./OrderInformationDenomination";
import { calculateBuyAmount, calculateOrderRowAmount, getRateAndAmounts } from "./OrderService";
import DynamicSelectWithSearch from "../shared/DynamicSelectWithSearch";
import { set } from "date-fns";
import { de } from "date-fns/locale";
import { Tooltip } from "@material-ui/core";
import { useContext } from "react";
import { OrderContext } from "./OrderScreen";

export function OrderInformationRow({ customerID, rowObject, rowID, buyCurrency, currenciesList, lockedSide, buyScale, onDeleteRow, onUpdateFieldRow, validations, onUpdateRowAmounts, onUpdateRowDenominations,
  deliveryDate, autoFocus, openAlert, editCostRate, showCostRate, editCustomerRate  }) {

    const [amount, setAmount] = useState(0);
    const [workingAmount, setWorkingAmount] = useState(0);
    const [amountEnteredByUser, setAmountEnteredByUser] = useState(0);  
    const [buyAmount, setBuyAmount] = useState(0);
    const [buyAmountFees, setBuyAmountFees] = useState(0);
    const [rate, setRate] = useState(0);
    const [costRate, setCostRate] = useState(0);
    const [profit, setProfit] = useState(0);
    const [ratePrecision, setRatePrecision] = useState(0);
    const [currencyID, setCurrencyID] = useState('');
    const [sellScale, setSellScale] = useState(2);  
    const [showDenominations, setShowDenominations] = useState(false);
    const [denominationType, setDenominationType] = useState(DenominationTypes.notes);
    const [denominations, setDenominations] = useState([]);
    const [inverseRate, setInverseRate] = useState(false);
    const [noteConditions, setNoteConditions] = useState('Regular');
    const [allowDenominationFees, setAllowDenominationFees] = useState(false);
    const [fees, setFees] = useState(0);

  const { setShowSpreadModal, rateStore, rowCurrencyId, setRowCurrencyId, rowSpreadID, setRowSpreadID, spreadUpdatedByUser, allowBankNotesEditSpread, setTimerIsRunning } = useContext(OrderContext);

    const conditionsList = [
      {name:'Regular',value:'Regular'},
      {name:'Mint',value:'Mint'},
      {name:'Out of circulation',value:'Out of circulation'}
    ]

    useEffect(() => {
    if (rowObject.CurrencyID && (rowObject.Denominations?.length > 0 || rowObject.MixedDenominations)) {     
        const selectCcy = currenciesList.find(c=> c.value===rowObject.CurrencyID);
        if(selectCcy)
        {
            dropdownCurrenciesChangeHandler(selectCcy);
        }
        const showInverseRate = rowObject.ShowInverseRate;
        const costRateInverseRate = showInverseRate? 1/rowObject.CostRate : rowObject.CostRate;
        const rateInverseRate = showInverseRate? 1/rowObject.Rate : rowObject.Rate;

        setInverseRate(showInverseRate);
        if(amount !== rowObject.Amount)
        {
          setAmount(rowObject.Amount);
        }
        if(rate !== rowObject.Rate)
        {
          setRate(rateInverseRate);
        }
        if(costRate !== rowObject.CostRate)
        {
          setCostRate(costRateInverseRate);
        }
        if(profit !== rowObject.Profit)
        {
          setProfit(rowObject.Profit);
        }
        if(buyAmount !== rowObject.BuyAmount)
        {
          setBuyAmount(rowObject.BuyAmount);
          setBuyAmountFees(rowObject.BuyAmount + fees);
        }
        setDenominationType(rowObject.DenominationType);
        setRatePrecision(rowObject.RatePrecision);
        setSellScale(rowObject.CurrencyScale);

        if(rowObject.NoteConditions)
        {
          setNoteConditions(rowObject.NoteConditions);
        }
    }
  }, [rowObject, currenciesList]);

   useEffect(() => {
    const updateRates = async () =>{
      if(amount > 0)
      {
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, amount, lockedSide,[], denominationType, buyScale, buyCurrency);
        if(rateResponse.Message && rateResponse.Message !== '')
        {
          openAlert('Error',rateResponse.Message );
        }
        else
        {
          onUpdateRowAmounts(rowID, amount, rateResponse.CustomerRate, rateResponse.BuyAmount, 0 ,denominations, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms, rateResponse.AverageRate);
          setRatePrecision(rateResponse.RatePrecision);
          setBuyAmount(rateResponse.BuyAmount);
          setBuyAmountFees(rateResponse.BuyAmount + fees);
          const costRateInverseRate = inverseRate? 1/rateResponse.CostRate : rateResponse.CostRate
          const rateInverseRate = inverseRate? 1/rateResponse.CustomerRate : rateResponse.CustomerRate
          
          setRate(rateInverseRate);
          setCostRate(costRateInverseRate);
          setProfit(rateResponse.Profit);
          setInverseRate(false);

          rateStore.update(rowID, { ...rateResponse, RowAmount: amount, RowId: rowID });
        }
      }
    }
    if (buyCurrency !== '') {
        updateRates()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buyCurrency]);

  const updateRates = async (currencyID, denominations) =>{
      /*if(amount > 0)
      {*/
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, amount, lockedSide,[], denominationType, buyScale, buyCurrency);
        if(rateResponse.Message && rateResponse.Message !== '')
        {
          openAlert('Error',rateResponse.Message );
        }
        else
        {
          onUpdateRowAmounts(rowID, amount, rateResponse.CustomerRate, rateResponse.BuyAmount, 0 , denominations, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms, rateResponse.AverageRate);
          setRatePrecision(rateResponse.RatePrecision);
          setBuyAmount(rateResponse.BuyAmount);
          setFees(0);
          setBuyAmountFees(rateResponse.BuyAmount);
          
          const costRateInverseRate = inverseRate? 1/rateResponse.CostRate : rateResponse.CostRate
          const rateInverseRate = inverseRate? 1/rateResponse.CustomerRate : rateResponse.CustomerRate
          setRate(rateInverseRate);
          setCostRate(costRateInverseRate);
          setProfit(rateResponse.Profit);
          setInverseRate(false);

          rateStore.update(rowID, { ...rateResponse, RowAmount: amount, RowId: rowID });
          
        }
      //}
    }

   /*useEffect(() => {
    
    if (currencyID !== ''){// && rowObject.CurrencyID !== currencyID) {
        updateRates()
    }
  }, [currencyID]);*/

  useEffect(() => {
    //setAmountEnteredByUser(rowObject.Amount);
    if (Array.isArray(rowObject.Denominations)) {
      const rowAmount = rowObject.Denominations.reduce((sum, denom) => sum + (denom.NoNotes * denom.DenominationValue), 0);
      setWorkingAmount(rowAmount);
    }
  }, [rowObject.Amount]);

  useEffect(() => {
    const rateInfo = rateStore?.get(rowID);
    if (!rateInfo) return;
    console.log('rateInfo', rateInfo)

    const orderRowAux = JSON.parse(JSON.stringify(rowObject))
    if(orderRowAux && orderRowAux.SpreadUpdatedByUser)
    {
      onUpdateFieldRow(rateInfo.RowId, 'Amount', rateInfo.RowAmount);
      setAmountEnteredByUser(rateInfo.RowAmount)

      onUpdateFieldRow(rateInfo.RowId, 'CostRate', rateInfo.CostRate);
      onUpdateFieldRow(rateInfo.RowId, 'Rate', rateInfo.CustomerRate);
      onUpdateFieldRow(rateInfo.RowId, 'Profit', rateInfo.Profit);    
      onUpdateFieldRow(rateInfo.RowId, 'AverageRate', rateInfo.AverageRate);

      const amountByRate = calculateBuyAmount(rateInfo.RateTerms, rateInfo.CustomerRate, lockedSide, orderRowAux.Amount, buyScale, inverseRate);
      onUpdateFieldRow(rateInfo.RowId, 'BuyAmount', amountByRate);
    }

  }, [spreadUpdatedByUser])

    const dropdownCurrenciesChangeHandler = async(item) =>
    {
       if(item.value && item.value !== '')
      { 
   if(rowObject.CurrencyID !== '' && rowObject.CurrencyID === item.value && (rowObject.Denominations.length > 0 || rowObject.MixedDenominations))
    {
        let denominationsRow = rowObject.Denominations.filter(dr => dr.NoNotes !== '' && Number(dr.NoNotes)> 0);
        //let denAux = item.Denominations;
        let denAux = JSON.parse(JSON.stringify(item.Denominations));

        if(denAux && denAux.length > 0 && denominationsRow )
        {
          await denAux.forEach(d => {
            const denOrder = denominationsRow.filter(dr => dr.DenominationDescription === d.DenominationDescription);
            if(denOrder && denOrder.length >0)
            {
              d.NoNotes = denOrder[0].NoNotes;
              d.DenominationFee = denOrder[0].DenominationFee;
            }
            else
            {
              d.NoNotes = 0;
              d.DenominationFee = 0;
            }
            d.valid = true;
          })
          setDenominations(denAux);
        }      
        setCurrencyID(rowObject.CurrencyID);
        setInverseRate(rowObject.ShowInverseRate);
        setAllowDenominationFees(item.AllowDenominationFees);
    }
    else{
      setCurrencyID(item.value);
      let denAux = [];
      if(item.Denominations)
      {        
        denAux = JSON.parse(JSON.stringify(item.Denominations));
        denAux.forEach((d) =>{
            d.valid = true;
            d.NoNotes = 0;
        })        
      }
      
      setDenominations(denAux);
      setBuyAmount(0);
      setBuyAmountFees(0);
      setRate(0);
      setCostRate(0);
      setProfit(0);
      setAmount(0);
      setInverseRate(false);
      setAllowDenominationFees(item.AllowDenominationFees);
      
      onUpdateFieldRow(rowID, 'CurrencyID', item.value);
      onUpdateFieldRow(rowID, 'CurrencyName', item.name);
      onUpdateFieldRow(rowID, 'CurrencyScale', item.NumberOfDecimals);
      onUpdateFieldRow(rowID, 'AllowDenominationFees', item.AllowDenominationFees);

      onUpdateRowAmounts(rowID, 0, 0, 0, 0 ,denAux, 0, 0, 8,'D',0);
      //onUpdateFieldRow(rowID, 'Denominations', denAux);
      updateRates(item.value, denAux);
    }
    
    setShowDenominations(true);
  }
    }

    const onBlurAmount = async() =>{
        clearDenominations();
        setAmountEnteredByUser(amount);
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, amount, lockedSide,[], denominationType, buyScale, buyCurrency);

        onUpdateRowAmounts(rowID, amount, rateResponse.CustomerRate, rateResponse.BuyAmount, 0 ,denominations, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms, rateResponse.AverageRate);
        setRatePrecision(rateResponse.RatePrecision);
        setBuyAmount(rateResponse.BuyAmount);
        setBuyAmountFees(rateResponse.BuyAmount + fees);
        const costRateInverseRate = inverseRate? 1/rateResponse.CostRate : rateResponse.CostRate
        const rateInverseRate = inverseRate? 1/rateResponse.CustomerRate : rateResponse.CustomerRate
        
        setRate(rateInverseRate);
        setCostRate(costRateInverseRate);
        setProfit(rateResponse.Profit);
        setInverseRate(false);

        rateStore.update(rowID, { ...rateResponse, RowAmount: amount, RowId: rowID });
    }

    const onBlurBuyAmount = async() => { //buySide    
        clearDenominations();
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, buyAmount, lockedSide.toLowerCase()==='sell'?'buy': 'sell',[], denominationType, buyScale, buyCurrency);
        onUpdateRowAmounts(rowID, rateResponse.BuyAmount, rateResponse.CustomerRate, buyAmount, 0, denominations, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms, rateResponse.AverageRate);
        setRatePrecision(rateResponse.RatePrecision);
        setAmount(rateResponse.BuyAmount);
        const costRateInverseRate = inverseRate? 1/rateResponse.CostRate : rateResponse.CostRate
        const rateInverseRate = inverseRate? 1/rateResponse.CustomerRate : rateResponse.CustomerRate
        
        setRate(rateInverseRate);
        setCostRate(costRateInverseRate);
        setProfit(rateResponse.Profit);
        setInverseRate(false);

        rateStore.update(rowID, { ...rateResponse, RowAmount: amount, RowId: rowID });
    }
    
    const onDeleteOrderRow = () => {
      onDeleteRow(rowID);
    };
  

  const onClickMore = () => {
    setShowDenominations(!showDenominations);   
  };

  const denominationIsValid = (denominations) =>{
    let valid = true;
    if(denominationType === DenominationTypes.amount)
    {
      if(denominations)
      {
        //const denominationsAux = JSON.parse(JSON.stringify(denominations))
        denominations.forEach((d)=>{          
          d.valid = (d.NoNotes === 0) || ((d.NoNotes > 0) && (d.DenominationValue <= d.NoNotes && d.NoNotes % d.DenominationValue === 0))     
          if(!d.valid) {valid = false}
        })
        setDenominations(denominations);
      }
    }

    return valid;
  }

  /*const onBlurDenominationValue = async (values) => {
    const denominationsAux = JSON.parse(JSON.stringify(denominations));
    denominationsAux.forEach((d, index) => {
      d.NoNotes = values[index];
    });
    setDenominations(denominationsAux);
    if (denominationIsValid(denominationsAux)) {
      const rowAmount = calculateOrderRowAmount(denominationsAux, denominationType);
      setWorkingAmount(rowAmount);
      setSyncAmount(true);
      if (rowAmount === 0) {
      }
    }
  }*/

  const onBlurDenominationValue = async (values) => {
    if (amountEnteredByUser === 0) {
      await onBlurDenominationValueNoValidation(values);
      return;
    }

    // Update denominations with new values    
    const updatedDenominations = denominations.map((d, index) => ({
      ...d,
      NoNotes: values[index]
    }));
    const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, buyAmount, lockedSide, updatedDenominations, denominationType, buyScale, buyCurrency);
    

    if(rateResponse.Denominations && rateResponse.Denominations.length > 0)
    {
      updatedDenominations.forEach((d) =>{
          const den = rateResponse.Denominations.find( df => df.DenominationDescription === d.DenominationDescription)
          if(den)
          {
          d.DenominationFee = den.DenominationFee??0;
          }
        } )
    }
    
    setDenominations(updatedDenominations);
debugger
    // Validate and calculate amount
    if (denominationIsValid(updatedDenominations)) {
      const rowAmount = calculateOrderRowAmount(updatedDenominations, denominationType);
      setWorkingAmount(rowAmount);
      onUpdateRowDenominations(rowID, updatedDenominations);
    }
 
    rateStore.update(rowID, { ...rateResponse, RowAmount: amount, RowId: rowID });
  };

  const onBlurDenominationValueNoValidation = async(values) =>{

        const denominationsAux = JSON.parse(JSON.stringify(denominations));
    denominationsAux.forEach((d, index)=>{ 
        d.NoNotes = values[index];
       });
     if(denominationIsValid(denominationsAux))
    {
      //const denominationsAux = JSON.parse(JSON.stringify(denominations));
      const rowAmount = calculateOrderRowAmount(denominationsAux, denominationType);
      if(rowAmount !== amount)
      {
        setAmount(rowAmount);
        debugger
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, rowAmount, lockedSide, denominationsAux, denominationType, buyScale, buyCurrency);
        
        const denominationsWithFee = [...denominationsAux];
        const denominationsFee = rateResponse.Denominations;
      
        let fee = 0;
        denominationsWithFee.forEach((d) => {
          if(denominationsFee && d.NoNotes > 0)
          {
            const denominationFee = denominationsFee.find((f) => d.DenominationDescription === f.DenominationDescription);
            d.DenominationFee = (denominationFee)?denominationFee.DenominationFee : 0;
            fee += (denominationFee)?denominationFee.DenominationFee : 0;
          }
          else
          {
            d.DenominationFee = 0;
          }
        })

        setDenominations(denominationsWithFee);

        onUpdateRowAmounts(rowID, rowAmount, rateResponse.CustomerRate, rateResponse.BuyAmount, fee, denominationsWithFee, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms, rateResponse.AverageRate);
        setRatePrecision(rateResponse.RatePrecision);
        setBuyAmount(rateResponse.BuyAmount);
        setBuyAmountFees(rateResponse.BuyAmount + fees);
        const costRateInverseRate = inverseRate? 1/rateResponse.CostRate : rateResponse.CostRate
        const rateInverseRate = inverseRate? 1/rateResponse.CustomerRate : rateResponse.CustomerRate
        
        setRate(rateInverseRate);
        setCostRate(costRateInverseRate);
        setProfit(rateResponse.Profit);

        rateStore.update(rowID, { ...rateResponse, RowAmount: amount, RowId: rowID });
      }
    }
  }

  const onUpdateDenominationValue = (value, index) =>{
    const denominationsAux = JSON.parse(JSON.stringify(denominations));
    denominationsAux[index].NoNotes =  value;    
    setDenominations(denominationsAux);
  }

  const onUpdateDenominationFeeValue = (value, index) =>{
    const denominationsAux = JSON.parse(JSON.stringify(denominations));
    denominationsAux[index].DenominationFee =  value;    
    let totalFees = 0;
    denominations.forEach(d => totalFees += Number(d.DenominationFee??0));
    setDenominations(denominationsAux);
    setFees(totalFees);
    setBuyAmountFees(buyAmount+totalFees);
    onUpdateRowDenominations(rowID, denominationsAux);
  }


  const onUpdateMixedNotes = (checked) =>{
    onUpdateFieldRow(rowID, 'MixedDenominations', checked);
    const denAux = clearDenominations();

    onUpdateRowDenominations(rowID, denAux);
    //onUpdateRowAmounts(rowID, 0,0,0,0, denAux,0,0,0,'D');
  }


   const onUpdateDenominationType = (checked) =>{
    const denType =  (checked)?DenominationTypes.notes: DenominationTypes.amount;
    setDenominationType(denType);
    onUpdateFieldRow(rowID, 'DenominationType', denType);
    const denAux = clearDenominations();
    onUpdateRowAmounts(rowID, 0,0,0,0, denAux,0,0,0,'D',0);
  }

  const clearDenominations = () =>{
    const denominationsAux = JSON.parse(JSON.stringify(denominations))
    denominationsAux.forEach(d => {d.NoNotes = 0; d.DenominationFee = 0;});
    setDenominations(denominationsAux);
    return denominationsAux;
  }

  const onBlurRate = ()=>{    
    const orderRowAux = JSON.parse(JSON.stringify(rowObject))
  
    const amountByRate = calculateBuyAmount(orderRowAux.RateTerms, rate, lockedSide, orderRowAux.Amount, buyScale, inverseRate);
    const costRateInverseRate = inverseRate? 1/ orderRowAux.CostRate : orderRowAux.CostRate
    const rateInverseRate = inverseRate? 1/rate : rate
    const amountByCostRate = calculateBuyAmount(orderRowAux.RateTerms, costRateInverseRate, lockedSide, orderRowAux.Amount, buyScale, inverseRate);
    //const profit = roundToDecimals(amountByRate - amountByCostRate, buyScale);
    const profit = roundToDecimals(
      lockedSide.toLowerCase() === 'buy' ? 
      (orderRowAux.RateTerms === 'I' ? amountByRate - amountByCostRate : amountByCostRate - amountByRate) :
      (orderRowAux.RateTerms === 'I' ? amountByCostRate - amountByRate : amountByRate - amountByCostRate),
      buyScale
      );
    if(rateInverseRate !== orderRowAux.Rate)
    {
      onUpdateFieldRow(rowID, 'AutorefreshRate', false);
    }

      onUpdateFieldRow(rowID, 'Rate', rateInverseRate);
      onUpdateFieldRow(rowID, 'Profit', profit);
      onUpdateFieldRow(rowID, 'BuyAmount', amountByRate);
      const rateInfo = rateStore?.get(rowID);
      if(rateInfo)
      {
        rateStore.update(rowID, { ...rateInfo, CustomerRate: rateInverseRate, Profit: profit, RowAmount: amount, RowId: rowID });
      }
      //rateStore.update(rowID, { ...rateInfo, RowAmount: amount, RowId: rowID });
  }

    const onBlurCostRate = ()=>{        
          
      const orderRowAux = JSON.parse(JSON.stringify(rowObject))
      

      const rateInverseRate = inverseRate? 1/ orderRowAux.Rate : orderRowAux.Rate
      const costRateInverseRate = inverseRate? 1/ costRate : costRate
      const amountByRate = calculateBuyAmount(orderRowAux.RateTerms, rateInverseRate, lockedSide, orderRowAux.Amount, buyScale,inverseRate);
      const amountByCostRate = calculateBuyAmount(orderRowAux.RateTerms, costRate, lockedSide, orderRowAux.Amount, buyScale,inverseRate);
      //const profit = roundToDecimals(amountByRate - amountByCostRate, buyScale);

      const profit = roundToDecimals(
        lockedSide.toLowerCase() === 'buy' ? 
        (orderRowAux.RateTerms === 'I' ? amountByRate - amountByCostRate : amountByCostRate - amountByRate) :
        (orderRowAux.RateTerms === 'I' ? amountByCostRate - amountByRate : amountByRate - amountByCostRate),
        buyScale
        );
      if(costRateInverseRate !== orderRowAux.CostRate)
      {
        onUpdateFieldRow(rowID, 'AutorefreshRate', false);
      }

      onUpdateFieldRow(rowID, 'CostRate', costRateInverseRate);      
      onUpdateFieldRow(rowID, 'Profit', profit);

      const rateInfo = rateStore?.get(rowID);
      if(rateInfo)
      {
        rateStore.update(rowID, { ...rateInfo, CostRate: costRateInverseRate, Profit: profit, RowId: rowID });
      }
  }


  const onClickInverseRate = () =>{

    const newValue = !inverseRate;
    setInverseRate(newValue)
    const inverseRateNew = 1/rate;
    const inverseCostRateNew = 1/costRate;

    setRate(inverseRateNew);
    setCostRate(inverseCostRateNew);
    
    onUpdateFieldRow(rowID, 'ShowInverseRate', newValue);
  }

  const dropdownConditionChangeHandler = (item) =>
  {
       if(item.value && item.value !== '')
      {
        setNoteConditions(item.value);
        onUpdateFieldRow(rowID, 'NoteConditions', item.value);
      }
  }


    return <>
    <tr key={rowID}>
        <td>
            <DynamicSelectWithSearch id={`dd-currencies-${rowID}`}
              key={`dd-currencies-${rowID}`}
              className={formatValidSelect(validations.CurrencyID)}
              data={currenciesList}
              placeholder='Select currency...'
              getValue={dropdownCurrenciesChangeHandler}
              objValue={{ value: currencyID }}
              autoFocus={autoFocus}/>     
        </td>
        <td>  
              <DynamicSelect key={`dd-condition-${rowID}`}
                id={`dd-condition-${rowID}`}
                className={formatValidSelect(validations.NoteConditions)}
                data={conditionsList}
                placeholder='Select a condition...'
                getValue={dropdownConditionChangeHandler}
                objValue={{value:noteConditions}}/> 
        </td>
        <td>
            <NumberInput id={`txt-amount-${rowID}`} key={`txt-amount-${rowID}`} className={formatValidInput(validations.Amount)} value={amount} 
            onBlur={onBlurAmount} onChange ={(event) => {setAmount(event.target.value);}} scale={sellScale} type="Currency" />
        </td>
        {showCostRate &&
        <td>
            <NumberInput id={`costrate-${rowID}`} key={`costrate-${rowID}`} className={formatValidInput(validations.Rate)} value={costRate} 
                    scale={ratePrecision} disabled={!editCostRate} onBlur={onBlurCostRate} onChange ={(event) => {setCostRate(event.target.value);}} type="Rate"/>
        </td>}
        <td>
            <NumberInput id={`rate-${rowID}`} key={`rate-${rowID}`} className={formatValidInput(validations.Rate)} value={rate} 
                    scale={ratePrecision} onBlur={onBlurRate} disabled={!editCustomerRate} onChange ={(event) => {setRate(event.target.value);}} type="Rate"/>
        </td>
        
        <td>
            <NumberInput id={`fees-${rowID}`} key={`fees-${rowID}`} className={formatValidInput(validations.BuyAmount)} value={fees} 
            scale={buyScale} disabled={true} type="Currency" />
        </td>
        <td>
            <NumberInput id={`buyAmount-${rowID}`} key={`buyAmount-${rowID}`} className={formatValidInput(validations.BuyAmount)} value={buyAmountFees} 
            onBlur={onBlurBuyAmount} onChange ={(event) => {setBuyAmount(event.target.value);}} scale={buyScale} disabled={true} type="Currency" />
        </td>
        {showCostRate &&
        <td>
            <NumberInput id={`profit-${rowID}`} key={`profit-${rowID}`} className={formatValidInput(validations.Rate)} value={profit} 
                    scale={buyScale} disabled={true} type="Currency" negative={true}/>
        </td>}
        <td style={{padding:'2px'}}>
            <DeleteTwoTone id={`delete-row-${rowID}`} key ={`delete-row-${rowID}`} style={{ marginRight: '10px', marginTop: '10px', cursor:'pointer'  }} onClick={onDeleteOrderRow} twoToneColor="#34c521"  />
          {!showDenominations && <AddCircleOutlineOutlined id={`show-den-row-${rowID}`} key ={`show-den-row-${rowID}`} style={{ marginTop: '10px', cursor:'pointer'  }} onClick={onClickMore} twoToneColor="#34c521"  />}
          {showDenominations && <RemoveCircleOutline id={`hide-den-row-${rowID}`} key ={`hide-den-row-${rowID}`} style={{ marginTop: '10px', cursor:'pointer'  }} onClick={onClickMore} twoToneColor="#34c521"  />}
           <Tooltip title="Inverse Rate">
           <AutorenewRounded id={`inverse-row-${rowID}`} key ={`inverse-row-${rowID}`} style={{ marginTop: '10px', marginLeft:'10px', cursor:'pointer' }} onClick={onClickInverseRate} className={`inverse-rate-icon${!inverseRate?'':'-selected'}`}/>
           </Tooltip>
          {allowBankNotesEditSpread && <Tooltip title="Edit Spread">
            <MonetizationOnOutlined id={`spread-row-${rowID}`} key={`spread-row-${rowID}`} style={{ marginTop: '10px', marginLeft: '10px', cursor: 'pointer' }}
              onClick={() => { setShowSpreadModal(true); setRowCurrencyId(currencyID); setRowSpreadID(rowID); setTimerIsRunning(false); }}/>
          </Tooltip>}
        </td>

    </tr>
    {showDenominations &&<tr key={`tr-den-${rowID}`}>
        <td colSpan={6}>
          <OrderInformationDenomination denominations={denominations} rowKey={`den-${rowID}`} onUpdateDenominationValue={onUpdateDenominationValue}
            onBlurDenominationValue={onBlurDenominationValue} valid={validations.Denominations} onUpdateDenominationType={onUpdateDenominationType}
            onUpdateMixedNotes={onUpdateMixedNotes} mixedNotes={rowObject.MixedDenominations} lockedSide={lockedSide} currencyID={currencyID} allowDenominationFees={allowDenominationFees}
            amountEnteredByUser={amountEnteredByUser} sellScale={sellScale} workingAmount={workingAmount}  onUpdateDenominationFeeValue={onUpdateDenominationFeeValue} />
        </td>
    </tr>}
    </>

}

export default OrderInformationRow